import Model, { hasMany } from '@warp-drive/legacy/model';
import type PostalAddressModel from './postal-address.ts';

export default class PostalAddressable extends Model {
  /*************************
   **  Relationships      **
   *************************/
  @hasMany('postal-address', {
    async: false,
    inverse: 'commentable',
    as: 'commentable',
  })
  declare postalAddresses: PostalAddressModel[];
}
